import { render, staticRenderFns } from "./AlertWaitingPromocode.vue?vue&type=template&id=bf1c2748&scoped=true&"
import script from "./AlertWaitingPromocode.vue?vue&type=script&lang=ts&"
export * from "./AlertWaitingPromocode.vue?vue&type=script&lang=ts&"
import style0 from "./AlertWaitingPromocode.vue?vue&type=style&index=0&id=bf1c2748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1c2748",
  null
  
)

export default component.exports